// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"d021d3c7","70":"69e5efd9","71":"4bebdff3","195":"c067cdaa","293":"5572e1c7","349":"84facb7d","360":"63e90648","397":"53bfa4be","419":"7b035c0e","606":"cf9ae65c","621":"49ca34aa","667":"f3d37756","870":"06fd5d06"}[chunkId] + ".chunk.js";
};